import { Action } from 'redux';
import { Epic, ofType } from 'redux-observable';
import { from, Observable, of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

import { LOAD_INTERNAL_PRODUCTS } from '../../../actions/products/internal/loadInternalProducts';
import {
    UpdateInternalProducts,
    updateInternalProductsAction
} from '../../../actions/products/internal/updateInternalProducts';
import {
    UpdateInternalProductsPageStatus,
    updateInternalProductsPageStatusAction
} from '../../../actions/products/internal/updateInternalProductsPageStatus';
import { selectProductsSortParams } from '../../../selectors/products';
import { EpicDeps } from '../../../service/StoreFactory';
import { ProductsPageStates } from '../../../typings/products';
import { State } from '../../../typings/state';

type EpicActions = UpdateInternalProducts | UpdateInternalProductsPageStatus;

export const loadInternalProductsEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$, deps) =>
    action$.pipe(
        ofType(LOAD_INTERNAL_PRODUCTS),
        mergeMap(
            (): Observable<EpicActions> => {
                return from(deps.productsDataProvider.getList()).pipe(
                    mergeMap(response => {
                        const sortParams = selectProductsSortParams(store$.value);

                        return of(
                            updateInternalProductsAction(response, sortParams),
                            updateInternalProductsPageStatusAction(ProductsPageStates.LOADED)
                        );
                    }),
                    catchError(() => of(updateInternalProductsPageStatusAction(ProductsPageStates.ERROR)))
                );
            }
        )
    );
